import { createContext, useContext } from "react";
import { ScenarioModel } from "./scenario.model";

export const ScenarioContext = createContext<ScenarioModel>(null as any);

export function useScenario() {
  return useContext(ScenarioContext);
}
